import axios from 'axios';

import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export interface LeaveRequest {
  id: number;
  employee_id: number;
  start_date: string;
  end_date: string;
  status?: string;
  type: string;
  reason: string;
  vacation_days: number;
  vacation_year: string;
  approved_days_this_year?: string;
  created_at: string;
  updated_at: string;
}

export const leaveRequestService = {
  getAll: async (): Promise<LeaveRequest[]> => {
    const response = await api.get('/leave-requests');
    return response.data;
  },

  create: async (data: Omit<LeaveRequest, 'id' | 'created_at' | 'updated_at'>): Promise<LeaveRequest> => {
    const response = await api.post('/leave-requests', data);
    return response.data;
  },

  approve: async (id: number): Promise<LeaveRequest> => {
    const response = await api.post(`/leave-requests/${id}/approve`);
    return response.data;
  },

  reject: async (id: number): Promise<LeaveRequest> => {
    const response = await api.post(`/leave-requests/${id}/reject`);
    return response.data;
  },

  onVacationThisMonth: async (month: number, year: number): Promise<LeaveRequest[]> => {
    const response = await api.get(`/leave-requests/on-vacation-this-month/${month}/${year}`);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/leave-requests/${id}`);
  }
}; 